import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { MoveInSidebarMenuItem as MoveInSidebarMenuItemInner } from './ui/MoveInSidebarMenuItem.tsx';
import type { Props } from './ui/types.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export const MoveInSidebarMenuItem = (props: Props) => (
	<JSErrorBoundary
		fallback="unmount"
		id="move-in-sidebar-menu-item"
		packageName={PACKAGE_NAME}
		teamName={TEAM_NAME}
	>
		<MoveInSidebarMenuItemInner {...props} />
	</JSErrorBoundary>
);
